import axios from '../shared/axios';
// import qs from 'querystring';
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";
import * as actionsDuck from "../store/ducks/actions.duck";


export function getRegisterList(contractid, includeassigned, accessibleWfIds) {
    return axios.post(`/api/ContractGenericDraft/RegisterList`, { accessibleWfIds }, { params: { contractid, includeassigned } });
}

export function assign(payload) {
    return axios.put(`/api/ContractGenericDraft/Assign`, payload);

}

export function deleteDraft(contractgenericdraftid) {
    return axios.delete(`/api/ContractGenericDraft/Delete`, { params: { contractgenericdraftid } });
}